var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68404 2.27688V3.8215H12.3163V2.27688H13.8603V3.8215H16.9485C17.1647 3.8215 17.3474 3.89616 17.4966 4.04547C17.6459 4.19479 17.7205 4.37757 17.7205 4.59381V16.9508C17.7205 17.1671 17.6459 17.3498 17.4966 17.4992C17.3474 17.6485 17.1647 17.7231 16.9485 17.7231H3.05182C2.83565 17.7231 2.65294 17.6485 2.50368 17.4992C2.35442 17.3498 2.27979 17.1671 2.27979 16.9508V4.59381C2.27979 4.37757 2.35442 4.19479 2.50368 4.04547C2.65294 3.89616 2.83565 3.8215 3.05182 3.8215H6.13997V2.27688H7.68404ZM16.1764 10H3.82386V16.1785H16.1764V10ZM6.13997 5.36613H3.82386V8.45538H16.1764V5.36613H13.8603V6.91075H12.3163V5.36613H7.68404V6.91075H6.13997V5.36613Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.78953f62a424ef880ea116c88b36b5ab.svg";
export { ForwardRef as ReactComponent };